import { render, staticRenderFns } from "./border-radius.vue?vue&type=template&id=aa90a22e"
import script from "./border-radius.vue?vue&type=script&lang=js"
export * from "./border-radius.vue?vue&type=script&lang=js"
import style0 from "./border-radius.vue?vue&type=style&index=0&id=aa90a22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports